import { cloneDeep } from 'lodash';
import { AnyAction } from 'redux';
import { DEFAULT_REPORTING_FILTERS } from '../../modules/reportingAndAnalytics/reportingUtils/reportingAndAnalyticsConstants';

const defaultInitialState = {
  selectedConfiguredPayers: {},
  reportingTransactionMeta: {},
  transactionReportFilters: DEFAULT_REPORTING_FILTERS,
  configPayer: [],
  claimStatus: [],
  isDateRangeClicked: false,
  reportingConfig: {},
  isRequestReportModalVisible: false,
  reportingDateRange: {},
  reportingDateRangeApplied: false,
  resetBtnClicked: 0,
};
const initialState = cloneDeep(defaultInitialState);

const reducer = (state: any = initialState, action: AnyAction): any => {
  switch (action.type) {
    case 'SET_SELECTED_CONFIGURED_PAYERS':
      return {
        ...state,
        selectedConfiguredPayers: action.payload,
      };
    case 'SET_REPORTING_TRANSACTION_META':
      return {
        ...state,
        reportingTransactionMeta: action.payload,
      };
    case 'SET_TRANSACTION_REPORT_FILTERS':
      return {
        ...state,
        transactionReportFilters: {
          ...state.transactionReportFilters,
          ...action.payload,
        },
      };

    case 'SET_CONFIG_PAYER':
      return {
        ...state,
        configPayer: action.payload,
      };
    case 'SET_CLAIM_STATUS':
      return {
        ...state,
        claimStatus: action.payload,
      };
    case 'SET_DATE_RANGE_CLICKED':
      return {
        ...state,
        isDateRangeClicked: action.payload,
      };
    case 'SET_REPORTING_CONFIG':
      return {
        ...state,
        reportingConfig: action.payload,
      };
    case 'SHOW_REQUEST_REPORT_MODAL':
      return {
        ...state,
        isRequestReportModalVisible: action.payload,
      };
    case 'REPORTING_DATE_RANGE':
      return {
        ...state,
        reportingDateRange: action.payload,
      };
    case 'REPORTING_DATE_RANGE_APPLIED': {
      return {
        ...state,
        reportingDateRangeApplied: action.payload,
      };
    }
    case 'CLEAR_STATE': {
      return cloneDeep(defaultInitialState);
    }
    case 'RESET_BTN_CLICKED': {
      return {
        ...state,
        resetBtnClicked: state.resetBtnClicked + 1,
      };
    }
    default:
      return state;
  }
};

export { reducer as reportingAndAnalyticsReducer };
